import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	daysLeft: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	daysLeftDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	daysLeft: {
		id: 'jsm-grace-period-banner.gp-awareness-pill.days-left',
		defaultMessage: ' {days, plural, one {#{symbol} day} other {#{symbol} days}} left',
		description: 'Days left until the GP end date',
	},
	daysLeftDefault: {
		id: 'jsm-grace-period-banner.gp-awareness-pill.days-left-default',
		defaultMessage: 'Action needed',
		description: 'Days left until the GP end date default',
	},
});
export default messages;
